import React, { Component } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import * as PropTypes from "prop-types";
import {BASE_URL} from "../../Constants";
import Link from "@material-ui/core/Link";
import { t } from '../../i18n';

const docWidth = 1200;

class BrowsePdf extends Component {
    state = {
        file: `${BASE_URL}${this.props.urlPath}`,
        numPages: null,
    };

    onDocumentLoadSuccess = ({ numPages }) =>
        this.setState({
            numPages,
        }
    );

    render() {
        const { file, numPages } = this.state;

        return (
            <div style={{ alignContent: "right", textAlign: "right"}}>
                <Link href={file} download>{ t('common.download') }</Link>
                <div style={{
                    alignContent: "center",
                    textAlign: "center",
                    height: "350px",
                    WebkitBoxShadow: "11px 10px 34px -4px rgba(0,0,0,0.58)",
                    MozBoxShadow: "11px 10px 34px -4px rgba(0,0,0,0.58)",
                    boxShadow: "11px 10px 34px -4px rgba(0,0,0,0.58)",
                    overflow: "scroll",
                    width: `${docWidth}px`
                }}>
                    <Document
                        file={file}
                        width={docWidth}
                        loading={ t('common.loadingFile') }
                        onLoadSuccess={this.onDocumentLoadSuccess}
                    >
                        {
                            Array.from(
                                new Array(numPages),
                                (el, index) => (
                                    <Page
                                        width={docWidth}
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                    />
                                ),
                            )
                        }
                    </Document>
                </div>
            </div>
        );
    }
}


BrowsePdf.propTypes = {
    urlPath: PropTypes.string.isRequired,
};

export default BrowsePdf;